import { Box, Typography } from '@mui/material';
import { getEventDiff, getRateRequestDetail } from 'common/modules/ShippingTimelineModal';
import PropTypes from 'prop-types';

const TimelineEventDetails = ({ event, expandedEventIds, toggleEventExpand }) => {
  const diff = getEventDiff(event);
  const rateDetail = getRateRequestDetail(event);
  if (!diff && !rateDetail) return null;
  const expandLabel =
    event?.auditEventType === 'SHIPMENT_ADDRESS_UPDATED' ? 'View address >' : 'View details >';
  const isOpen = expandedEventIds.includes(event?.auditEventId);

  return (
    <>
      <Typography
        variant='body2'
        color='primary.main'
        sx={{ cursor: 'pointer', display: 'block', mt: 0.25 }}
        onClick={() => toggleEventExpand(event?.auditEventId)}
      >
        {isOpen ? 'Hide' : expandLabel}
      </Typography>
      {diff && isOpen && (
        <Box
          sx={{
            mt: 1,
            p: 1.5,
            bgcolor: 'grey.50',
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 1,
            maxWidth: 380,
          }}
        >
          <Box sx={{ mb: 1 }}>
            <Typography
              variant='caption'
              color='text.primary'
              sx={{ fontWeight: 700, letterSpacing: 0.5, display: 'block', mb: 0.25 }}
            >
              PREVIOUS ADDRESS
            </Typography>
            <Typography variant='body2' color='text.secondary'>
              {diff.before}
            </Typography>
          </Box>
          <Box>
            <Typography
              variant='caption'
              color='success.main'
              sx={{ fontWeight: 700, letterSpacing: 0.5, display: 'block', mb: 0.25 }}
            >
              UPDATED ADDRESS
            </Typography>
            <Typography variant='body2' color='text.primary'>
              {diff.after}
            </Typography>
          </Box>
        </Box>
      )}

      {rateDetail && isOpen && (
        <Box
          sx={{
            mt: 1,
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 1,
            overflow: 'hidden',
            maxWidth: 420,
          }}
        >
          {rateDetail.rows.map(({ label, value }, i) => (
            <Box
              key={label}
              sx={{
                display: 'flex',
                borderBottom:
                  i < rateDetail.rows.length - 1 || rateDetail.address ? '1px solid' : 'none',
                borderColor: 'divider',
              }}
            >
              <Box
                sx={{
                  width: 90,
                  flexShrink: 0,
                  px: 1.25,
                  py: 0.6,
                  bgcolor: 'grey.50',
                  borderRight: '1px solid',
                  borderColor: 'divider',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Typography
                  variant='caption'
                  color='text.secondary'
                  sx={{
                    fontWeight: 700,
                    textTransform: 'uppercase',
                    fontSize: 10,
                    letterSpacing: 0.4,
                  }}
                >
                  {label}
                </Typography>
              </Box>
              <Box sx={{ px: 1.25, py: 0.6, flex: 1 }}>
                <Typography variant='body2'>{value}</Typography>
              </Box>
            </Box>
          ))}
          {rateDetail.address && (
            <Box sx={{ display: 'flex' }}>
              <Box
                sx={{
                  width: 90,
                  flexShrink: 0,
                  px: 1.25,
                  py: 0.6,
                  bgcolor: 'grey.50',
                  borderRight: '1px solid',
                  borderColor: 'divider',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Typography
                  variant='caption'
                  color='text.secondary'
                  sx={{
                    fontWeight: 700,
                    textTransform: 'uppercase',
                    fontSize: 10,
                    letterSpacing: 0.4,
                  }}
                >
                  Address
                </Typography>
              </Box>
              <Box sx={{ px: 1.25, py: 0.6, flex: 1 }}>
                <Typography variant='body2'>{rateDetail.address}</Typography>
              </Box>
            </Box>
          )}
        </Box>
      )}
    </>
  );
};

TimelineEventDetails.propTypes = {
  event: PropTypes.shape({
    auditEventType: PropTypes.string,
    auditEventId: PropTypes.string,
  }).isRequired,
  expandedEventIds: PropTypes.arrayOf(PropTypes.string),
  toggleEventExpand: PropTypes.func,
};

TimelineEventDetails.defaultProps = {
  expandedEventIds: [],
  toggleEventExpand: () => {},
};

export default TimelineEventDetails;
